import type { LifecycleActionModalI18nKeys } from '../elements/LifecycleActionModal'

export const REFUSE_I18N_KEYS: LifecycleActionModalI18nKeys = {
  title: 'receipts.modal.reject_e_invoice.title',
  message: 'receipts.modal.reject.french.market.e_invoice.message',
  specifyReason: 'receipts.modal.reject_e_invoice.specify_reason',
  specifyReasonError: 'receipts.modal.reject_e_invoice.reason.required',
  selectReason: 'receipts.modal.reject_e_invoice.select_reason',
  optionalComment: 'receipts.modal.reject_e_invoice.optional_comment',
  mandatoryComment: 'receipts.modal.reject_e_invoice.mandatory_comment',
  optionalCommentPlaceholder: 'receipts.modal.reject_e_invoice.optional_comment_placeholder',
  commentRequiredError: 'receipts.modal.reject_e_invoice.comment.required',
  bottomMessage: 'receipts.modal.reject_e_invoice_bottom_message',
  learnMoreUrl: 'receipts.modal.reject_e_invoice_learn_more_url',
  learnMore: 'receipts.modal.reject_e_invoice_learn_more',
  button: 'receipts.modal.reject_e_invoice.button',
}

export const DISPUTE_I18N_KEYS: LifecycleActionModalI18nKeys = {
  title: 'receipts.modal.dispute_e_invoice.title',
  message: 'receipts.modal.dispute_e_invoice.message',
  specifyReason: 'receipts.modal.dispute_e_invoice.specify_reason',
  specifyReasonError: 'receipts.modal.dispute_e_invoice.reason.required',
  selectReason: 'receipts.modal.dispute_e_invoice.select_reason',
  optionalComment: 'receipts.modal.dispute_e_invoice.optional_comment',
  mandatoryComment: 'receipts.modal.dispute_e_invoice.mandatory_comment',
  optionalCommentPlaceholder: 'receipts.modal.dispute_e_invoice.optional_comment_placeholder',
  commentRequiredError: 'receipts.modal.dispute_e_invoice.comment.required',
  bottomMessage: 'receipts.modal.dispute_e_invoice.bottom_message',
  learnMoreUrl: 'receipts.modal.dispute_e_invoice.learn_more_url',
  learnMore: 'receipts.modal.dispute_e_invoice.learn_more',
  button: 'receipts.modal.dispute_e_invoice.button',
}

export const SUSPEND_I18N_KEYS: LifecycleActionModalI18nKeys = {
  title: 'receipts.modal.suspend_e_invoice.title',
  message: 'receipts.modal.suspend_e_invoice.message',
  specifyReason: 'receipts.modal.suspend_e_invoice.specify_reason',
  specifyReasonError: 'receipts.modal.suspend_e_invoice.reason.required',
  selectReason: 'receipts.modal.suspend_e_invoice.select_reason',
  optionalComment: 'receipts.modal.suspend_e_invoice.optional_comment',
  mandatoryComment: 'receipts.modal.suspend_e_invoice.mandatory_comment',
  optionalCommentPlaceholder: 'receipts.modal.suspend_e_invoice.optional_comment_placeholder',
  commentRequiredError: 'receipts.modal.suspend_e_invoice.comment.required',
  bottomMessage: 'receipts.modal.suspend_e_invoice.bottom_message',
  learnMoreUrl: 'receipts.modal.suspend_e_invoice.learn_more_url',
  learnMore: 'receipts.modal.suspend_e_invoice.learn_more',
  button: 'receipts.modal.suspend_e_invoice.button',
}
